import loginBoxMcComponent from './login-box-mc/login-box-mc.component';
import loginBoxComponent from './login-box/login-box.component';
import loginDialogComponent from './login-dialog.component';
import registerComponent from './register/register.component';

export default angular
  .module('fizyweb.paycell.loginDialog', [])
  .component('loginDialog', loginDialogComponent)
  .component('register', registerComponent)
  .component('loginBox', loginBoxComponent)
  .component('loginBoxMc', loginBoxMcComponent).name;



// WEBPACK FOOTER //
// src/app/components/login-dialog/login-components.module.ts